<template>
    <el-card class="yl-tabs-table">
        <el-row v-if="options.enable">
            <!-- style 为占位 -->
            <el-col :span="6" class="yl-tabs-title" style="min-height:1px">
                <div v-html="computedContents" v-if="options.dataSource.isHtml"></div>
                <div v-else>{{computedContents}}</div>
            </el-col>
            <el-col :span="18" class="text-right">
                <template v-for="(item,index) in options.buttonList">
                    <yl-lc-button 
                        v-if="show(item) && item.on && item.on.find(child=>child.name=='click')"
                        :ref="`button${index}`"
                        :type="item.type" 
                        :plain="item.plain" 
                        :icon="item.icon" 
                        :name="item.name" 
                        :key="index"
                        :data="item"
                        :disabled="isDisabled(item) && item.on && item.on.some(child=>child.name=='click')"
                        @click.native="clickScript(item)"
                    >
                    </yl-lc-button>
                    <yl-lc-button 
                        v-if="show(item) && item.on && item.on.find(child=>child.name=='changeChecked')"
                        :ref="`button${index}`"
                        :type="item.type" 
                        :plain="item.plain" 
                        :icon="item.icon" 
                        :name="item.name" 
                        :key="index"
                        :data="item"
                        :disabled="isDisabled(item) && item.on && item.on.some(child=>child.name=='changeChecked')"
                        @change="runScript"
                    >
                    </yl-lc-button>
                </template>
            </el-col>
        </el-row>
        <slot></slot>
    </el-card>
</template>
<script>
export default {
    name:"yl-lc-card",
    components: {
    },
    props: {
        enable:{
            type:Boolean,
            default:false
        },
        title:{
            type:Object,
        }
    },
    data() {
        return {
            options:{
                enable:false,
                name:"标题名称",
                buttonList:[],
                dataSource: {
                    isHtml: false,
                    body: '标题名称'
                }
            },
            button: null,
            htmlContent: null
        }
    },
    watch: {
        "title": {
            handler(val) {
                val.buttonList.forEach(item => {
                    if(!item.isDisabled){
                        item.isDisabled = {
                            isAction:true,
                            body:"",
                            status: false
                        }
                    }
                });
                if(!val.hasOwnProperty('dataSource')) {
                    val.dataSource = {
                        isHtml: true,
                        body: ''
                    }
                }else{
                    if(val.dataSource.isHtml){
                        this.htmlContent = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(val.dataSource.body) : this.$store.getters.getTextHtml(val.dataSource.body)
                    }else{
                        this.htmlContent = window.LOWCODE.source ? this.$lowcode.createMatchField(val.dataSource.body) : this.$store.getters.getSourceVal(val.dataSource.body);
                    }
                }
                Object.assign(this.options,val);
            },
            immediate: true
        }
    },
    computed: {
        computedContents() {
            let computedContent = null
            if(this.options.dataSource.isHtml){
                computedContent = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(this.options.dataSource.body) : this.$store.getters.getTextHtml(this.options.dataSource.body)
            }else{
                computedContent = window.LOWCODE.source ? this.$lowcode.createMatchField(this.options.dataSource.body) : this.$store.getters.getSourceVal(this.options.dataSource.body);
            }
            return computedContent;
        }
    },
    mounted() {
    },
    methods: {
        getVal(index){
            return this.$refs[`button${index}`][0].value;
        },
        setVal(index,propValue){
            this.$refs[`button${index}`][0].value = propValue;
        },
        setName(index,propValue){
            this.$refs[`button${index}`][0].label = propValue;
        },
        show(item){
            if(item.isShow.isAction){
                return item.isShow.status;
            }
            if(!item.isShow.isAction){
                if(window.LOWCODE.source){
                    return this.$lowcode.execute(item.isShow.body);
                }
                if(!window.LOWCODE.source){
                    return this.$store.getters.getPageObject(item.isShow.body);
                }
            }
        },
        isDisabled(item){
            if(item.isDisabled.isAction){
                return item.isDisabled.status;
            }
            if(!item.isDisabled.isAction){
                if(window.LOWCODE.source){
                    return this.$lowcode.execute(item.isDisabled.body);
                }
                if(!window.LOWCODE.source){
                    return this.$store.getters.getPageObject(item.isDisabled.body);
                }
            }
        },
        runScript(ev){
            let data = ev.event || ev;
            let eventObj = data.__on__ && data.__on__.length>0 ? data.__on__[0] : null;
            if(eventObj && window.LOWCODE.source){
                this.$lowcode.executeEvent(eventObj,ev.value)();
            }
            if(eventObj && !window.LOWCODE.source){
                this.$store.getters.exeMethods(eventObj,ev.value);
            }
        },
        clickScript(data){
            let disabled = this.isDisabled(data) && data.on && data.on.some(child=>child.name=='click')
            if(!disabled){
                let eventObj = data.__on__ && data.__on__.length>0 ? data.__on__[0] : null;
                if(eventObj && window.LOWCODE.source){
                    this.$lowcode.executeEvent(eventObj)();
                }
                if(eventObj && !window.LOWCODE.source){
                    this.$store.getters.exeMethods(eventObj);
                }
            }
        },
        showStatus(item){

        }
    }
}
</script>